import InspectionPage from "../pages/sellerAuction/inspection/InspectionPage";
import PageNotFound from "../pages/commanPage/errorPage/PageNotFound";
import HomePage from "../pages/sellerAuction/dashboard/HomePage";
import CreateOfferForAuction from "../pages/sellerAuction/createAuction/CreateOfferForAuction";
import AuctionStatusDetail from "../pages/sellerAuction/auctionStatus/AuctionStatusDetail";
import TodayAuctions from "../pages/sellerAuction/auctions/pages/TodayAuctions";
import SingleAuctionPage from "../pages/sellerAuction/dashboard/singleAuction/SingleAuctionPage";
import SingleOfferDetails from "../pages/sellerAuction/dashboard/singleOffer/SingleOfferDetails";
import OfferBidsDetails from "../pages/sellerAuction/completedAuction/component/OfferBidsDetails";
import CatalogueDowloadBy from "../pages/sellerAuction/dashboard/singleAuction/table/CatalogueDowloadBy";
import CatelogueViewBy from "../pages/sellerAuction/dashboard/singleAuction/table/CatelogueViewBy";
import CatelogueAcceptedBy from "../pages/sellerAuction/dashboard/singleAuction/table/CatelogueAcceptedBy";
import SellerTodayAuctions from "../pages/sellerAuction/updateLiveRoom/SellerTodayAuction";
import LiveRoomForLots from "../pages/sellerAuction/updateLiveRoom/LiveRoomForLots";
import CompletdSingleAuction from "../pages/sellerAuction/completedAuction/CompletdSingleAuction";
import CreateAuction from "../pages/sellerAuction/createAuction/RescheduleAuction";
import AuctionReportPdf from "../pages/sellerAuction/dashboard/auctionReport/auctionReportPdf/AuctionReportPdf";
import ServiceSingleAuctionPage from "../pages/sellerAuction/dashboard/singleAuction/ServiceSingleAuctionPage";
import ProductSingleAuctionPage from "../pages/sellerAuction/dashboard/singleAuction/ProductSingleAuctionPage";
import SingleServiceLotDetails from "../pages/sellerAuction/dashboard/singleOffer/SingleServiceLotDetails";
import SingleProductLotDetails from "../pages/sellerAuction/dashboard/singleOffer/SingleProductLotDetails";
import ServiceLiveRoomForLots from "../pages/sellerAuction/updateLiveRoom/ServiceLiveRoomForLots";
import ProductLiveRoomLots from "../pages/sellerAuction/updateLiveRoom/ProductLiveRoomLots";
import CompletedServiceSingleAuction from "../pages/sellerAuction/completedAuction/CompletedServiceSingleAuction";
import ServiceOfferBidDetails from "../pages/sellerAuction/completedAuction/component/ServiceOfferBidDetails";
import CompletedProductSingleAuction from "../pages/sellerAuction/completedAuction/CompletedProductSingleAuction";
import ProductOfferBidDetail from "../pages/sellerAuction/completedAuction/component/ProductOfferBidDetail";

export const sellerRoutes = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "today-auction",
    element: <TodayAuctions />,
  },
  {
    path: "reschedule-auction/:id",
    element: <CreateAuction />,
  },
  {
    path: "auction-status",
    element: <AuctionStatusDetail />,
  },
  {
    path: "/forward-auction/single-auction/:id",
    element: <SingleAuctionPage />,
  },
  {
    path: "/service-reverse-auction/single-auction/:id",
    element: <ServiceSingleAuctionPage />,
  },
  {
    path: "/product-reverse-auction/single-auction/:id",
    element: <ProductSingleAuctionPage />,
  },
  {
    path: "/forward-auction/completed-single-auction/:id",
    element: <CompletdSingleAuction />,
  },
  {
    path: "/service-reverse-auction/completed-single-auction/:id",
    element: <CompletedServiceSingleAuction />,
  },
  {
    path: "/product-reverse-auction/completed-single-auction/:id",
    element: <CompletedProductSingleAuction />,
  },
  {
    path: "single-auction/:id/:catalogueId/downlaodBy",
    element: <CatalogueDowloadBy />,
  },
  {
    path: "single-auction/:id/:catalogueId/viewBy",
    element: <CatelogueViewBy />,
  },
  {
    path: "single-auction/:id/:catalogueId/acceptedBy",
    element: <CatelogueAcceptedBy />,
  },
  {
    path: "auction-report/:id",
    element: <AuctionReportPdf />,
  },
  {
    path: "/forward-auction/singleOffer/:id/:offerId",
    element: <SingleOfferDetails />,
  },
  {
    path: "/service-reverse-auction/singleOffer/:id/:offerId",
    element: <SingleServiceLotDetails />,
  },
  {
    path: "/product-reverse-auction/singleOffer/:id/:offerId",
    element: <SingleProductLotDetails />,
  },
  {
    path: "/forward-auction/offerBids/:id/:offerId",
    element: <OfferBidsDetails />,
  },
  {
    path: "/service-reverse-auction/offerBids/:id/:offerId",
    element: <ServiceOfferBidDetails />,
  },
  {
    path: "/product-reverse-auction/offerBids/:id/:offerId",
    element: <ProductOfferBidDetail />,
  },
  {
    path: "createAuction-lots/:id",
    element: <CreateOfferForAuction />,
  },
  {
    path: "inspectList",
    element: <InspectionPage />,
  },
  {
    path: "seller-live-auctions",
    element: <SellerTodayAuctions />,
  },
  {
    path: "/forward-auction/live-room/:id/:catalogueId",
    element: <LiveRoomForLots />,
  },
  {
    path: "/reverse-product-auction/live-room/:id/:catalogueId",
    element: <ProductLiveRoomLots />,
  },
  {
    path: "/reverse-service-auction/live-room/:id/:catalogueId",
    element: <ServiceLiveRoomForLots />,
  },
  // {
  //   path: "/download-auctionBid/:id/:offerId",
  //   element: <DownloadAuctionBid/>,
  // },
  {
    path: "*",
    element: <PageNotFound />,
  },
];
